import React from 'react';
// Compact value widgets for option-based filters (tags, sites) and the site
// region filter. Each button summarises the current selection; clicking
// opens the matching dialog, which is rendered by the parent ConditionRow.

export function PickerButton({ noun, options, values, onPick }) {
  const selected = values || [];
  const labels = (options || []).filter((o) => selected.includes(o.value)).map((o) => o.label);
  const summary =
    selected.length === 0
      ? 'none selected'
      : labels.slice(0, 3).join(', ') + (labels.length > 3 ? ` +${labels.length - 3} more` : '');
  return (
    <button type="button" className="condition-pick" onClick={onPick}>
      <span className="condition-pick-label">Select {noun}</span>
      <span className="condition-pick-summary">{summary}</span>
    </button>
  );
}

export function BoundsButton({ values, onPick }) {
  const box = (values || []).map(Number);
  const has = box.length === 4 && box.every(Number.isFinite);
  const fmt = (v) => v.toFixed(2);
  return (
    <button type="button" className="condition-pick" onClick={onPick}>
      <span className="condition-pick-label">Select region on map</span>
      <span className="condition-pick-summary">
        {has
          ? `${fmt(box[1])}, ${fmt(box[0])} – ${fmt(box[3])}, ${fmt(box[2])}`
          : 'no region selected'}
      </span>
    </button>
  );
}
